import { Component, EventEmitter } from '@angular/core';
import { Widget, WidgetSunstudy, WidgetSunstudyView } from '../../models/widget';
import { WidgetService } from '../widget.service';
import { SunstudyService } from '../sunstudy.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalComponent } from '../../core/modal.component';
import { ActiveModal } from '../../core/modal.service';

@Component({
  selector: 'app-sunstudio-modal',
  templateUrl: './sunstudio-modal.component.html',
})
export class SunstudioModalComponent extends ModalComponent {
  widget: Widget;
  sunstudy: WidgetSunstudy;
  form: FormGroup;
  updates: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private widgetService: WidgetService,
              private sunstudyService: SunstudyService,
              private fb: FormBuilder,
              public activeModal: ActiveModal) {

    super(activeModal);
    this.form = this.fb.group({
      name: ['', Validators.required]
    });
  }

  ngOnInit() {
  }

  init(widget: Widget, sunstudy?: WidgetSunstudy) {
    this.widget = widget;

    if (sunstudy) {
      this.loadSunstudy(sunstudy);
    } else {
      this.sunstudy = new WidgetSunstudy();
    }

    this.opened = true;
  }

  showCreateView(data: any) {
    const name = prompt('Namn');

    this.sunstudyService.createView(this.sunstudy, { name: name })
      .subscribe(view => {
        this.loadSunstudy(this.sunstudy);
        this.updates.emit(true);
      });
  }

  updateView(data: any, view: WidgetSunstudyView) {
    this.loadSunstudy(this.sunstudy);
  }

  deleteView(view: WidgetSunstudyView) {
    if (!confirm('Ta bort vy?')) {
      return;
    }
    this.sunstudyService.deleteView(view).subscribe(() => {
      this.loadSunstudy(this.sunstudy);
      this.updates.emit(true);
    });
  }

  addView() {
    this.sunstudy.views.push(new WidgetSunstudyView());
  }

  removeView() {
  }

  save() {
    const value = this.form.value;

    if (this.isEditing) {
      this.sunstudyService.update(this.sunstudy, value).subscribe(sunstudy => {
        this.sunstudy = sunstudy;
      });
    } else {
      this.sunstudyService.create(this.widget, value).subscribe(sunstudy => {
        this.sunstudy = sunstudy;
      });
    }

    this.updates.emit(true);
  }

  private loadSunstudy(sunstudy: WidgetSunstudy) {
    this.widgetService.getSunstudy(this.widget, sunstudy.id).subscribe(sunstudy => {
      this.sunstudy = sunstudy;

      this.form.setValue({ name: sunstudy.name });
    });
  }

  get isEditing() {
    return this.sunstudy && this.sunstudy.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/sunstudio-modal/sunstudio-modal.component.ts